// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__RhqX0","gfeWrapper":"CalendarEvent_gfeWrapper__31k4Q"};